<template>

    <div class="col-12">
        <div v-if="scheme === 'ecoamaps'">
            <ecoamaps-your-profile-scheme-details-component
                :product="product"
                :profile="profile"
                :companyCarScheme="companyCarScheme"
                :essentialBusinessScheme="essentialBusinessScheme"

            />
        </div>
        <div v-else-if="scheme === 'salsac'">
            <salsac-your-profile-scheme-details-component
                :product="product"
                :profile="profile"
            />
        </div>
        <div v-else-if="scheme === 'bch' && adminPortalData">
            <bch-your-profile-scheme-details-component
                :product="product"
                :profile="profile"
                :adminPortalData="adminPortalData"
            />
        </div>
        <div v-else class="text-center mt-4">
            <LoadingIcon/>
        </div>
    </div>

</template>

<script>

import SalsacYourProfileSchemeDetailsComponent from "./your-profile/salsac/your-profile-scheme-details-component";
import EcoamapsYourProfileSchemeDetailsComponent from "./your-profile/ecoamaps/your-profile-scheme-details-component";
import BchYourProfileSchemeDetailsComponent from "./your-profile/bch/your-profile-scheme-details-component";
import LoadingIcon from "./loading-icon";

export default {
    name: 'your-profile-scheme-details-component',
    components: {
        LoadingIcon,
        BchYourProfileSchemeDetailsComponent,
        EcoamapsYourProfileSchemeDetailsComponent,
        SalsacYourProfileSchemeDetailsComponent
    },
    props: [
        'profile',
        'companyCarScheme',
        'essentialBusinessScheme',
        'product',
        'scheme',
        'tooltip',
        'adminPortalData',
    ],
}
</script>

